import { Box } from '@mui/material';

type MemberAccordionWrapperProps = {
  hasError: boolean;
  children: JSX.Element;
};

export const MemberAccordionWrapper = (props: MemberAccordionWrapperProps) => {
  const { hasError, children } = props;

  return (
    <Box
      sx={{
        border: (theme) => (hasError ? `8px solid ${theme.palette.error.main}` : 'none'),
        '& .MuiAccordionSummary-root': {
          flexDirection: 'row-reverse',
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
          '& .MuiAccordionSummary-content': {
            ml: 1,
          },
        },
        '& .MuiAccordion-root.Mui-expanded': {
          borderBottom: '1px solid #e0e0e0',
          boxShadow: '0 20px 15px -20px rgba(0, 0, 0, 0.1) inset !important',
          margin: 0,
        },
      }}
    >
      {children}
    </Box>
  );
};
